import { Outlet, useParams } from "react-router-dom";

import { useAuth } from "@/modules/auth";

import { TabsWithRoute } from "@/components/TabsWithRoute";
import { ScrollableTabs } from "@/components/ScrollableTabs";
import { TabsContainer } from "../TabsContainer";

import "./styles.scss";

export function SafeSurgery() {
	const { attendanceId } = useParams();
	const { currentAuth } = useAuth();

	return (
		<>
			<TabsContainer>
				<ScrollableTabs>
					{currentAuth?.user.can("View-Pre-Anesthetic-Induction") && (
						<TabsWithRoute
							name="Pré-Indução Anestésica"
							route={`/atendimento/${attendanceId}/cirurgia-segura/pre-inducao-anestesica`}
						/>
					)}

					{currentAuth?.user.can("View-Pre-Surgery") && (
						<TabsWithRoute
							name="Pré-Cirurgia"
							route={`/atendimento/${attendanceId}/cirurgia-segura/pre-cirurgia`}
						/>
					)}

					{currentAuth?.user.can("View-Pre-Recovery-Room") && (
						<TabsWithRoute
							name="Pré-Sala de Recuperação"
							route={`/atendimento/${attendanceId}/cirurgia-segura/pre-sala-de-recuperacao`}
						/>
					)}

					{currentAuth?.user.can("View-Recovery-Room") && (
						<TabsWithRoute
							name="Sala de Recuperação"
							route={`/atendimento/${attendanceId}/cirurgia-segura/sala-de-recuperacao`}
						/>
					)}
				</ScrollableTabs>
			</TabsContainer>

			{/* portal */}
			<div id="safe-surgery-content">
				<Outlet />
			</div>
		</>
	);
}
